var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskMeterHorizontalHabits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 59,
    viewBox: "0 0 318 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 318,
    height: 59,
    rx: 29,
    transform: "matrix(-1 0 0 1 318 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316 29.5C316 14.3122 303.688 2 288.5 2H284.667V57H288.5C303.688 57 316 44.6878 316 29.5Z",
    fill: "#8BC53F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316 29.5C316 14.3122 303.688 2 288.5 2H284.667V57H288.5C303.688 57 316 44.6878 316 29.5Z",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 278.667 0)",
    fill: "#8BC53F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 278.667 0)",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 243.333 0)",
    fill: "#FFCD29"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 243.333 0)",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 208 0)",
    fill: "#FFCD29"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 208 0)",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 172.667 0)",
    fill: "#FF4F53"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 172.667 0)",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 137.333 0)",
    fill: "#FF4F53"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 137.333 0)",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 102 0)",
    fill: "#FF4F53"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 102 0)",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 66.6666 0)",
    fill: "#FF4F53"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 31.3333,
    height: 55,
    transform: "matrix(-1 0 0 1 66.6666 0)",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 2H29.4999C14.3121 2 1.99992 14.3122 1.99992 29.5C1.99992 44.6878 14.3121 57 29.4999 57H33.3333V2Z",
    fill: "#FF4F53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 2H29.4999C14.3121 2 1.99992 14.3122 1.99992 29.5C1.99992 44.6878 14.3121 57 29.4999 57H33.3333V2Z",
    stroke: "#EFEFFF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskMeterHorizontalHabits);
export default __webpack_public_path__ + "static/media/RiskMeterHorizontalHabits.006f81e9e65477b36cadf0564102095c.svg";
export { ForwardRef as ReactComponent };